module.exports = __webpack_public_path__ + "img/icon-barbara.58bff730.webp";